export default __webpack_public_path__ + "static/media/wireless.inline.dbab58c6.svg";